module.exports = __webpack_public_path__ + "static/media/cartoon_me.36603699.png";